module.exports = __webpack_public_path__ + "media/images/triangle--down--rb-dark-blue-02347afaf2049bf24e3cf4430499c15a.png";